const StarMiniIcon = () => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><g clipPath="url(#a)"><path fill="#FFA800" d="M9.194 11.693 5.867 9.612l-3.326 2.081a.35.35 0 0 1-.528-.383l.952-3.807-2.972-2.52a.351.351 0 0 1 .201-.62l3.88-.271L5.54.452c.108-.266.545-.266.652 0l1.468 3.64 3.879.27a.352.352 0 0 1 .202.621l-2.973 2.52.952 3.807a.35.35 0 0 1-.527.383Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
  )
}

export default StarMiniIcon;